module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "copyright-page",
      "id": "cip"
    }
  }, [_c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "iv",
      "id": "piv",
      "role": "doc-pagebreak"
    }
  }), _c('b', [_vm._v("Frontispiece:")]), _vm._v(" The recently discovered “pseudo-orb” of the New Guinean psechrid "), _c('i', [_vm._v("Fecenia ochracea")]), _vm._v(" is a spectacular example of a major theme of this book, evolutionary convergence. Although the spider is not closely related to the “true” orb weavers (Orbiculariae) its web shares with orbs a planar, aerial array of non-sticky radial lines that converge on a hub, frame lines that support the radii, and a uniformly spaced array of more or less circular sticky lines laid on the radii. The recent nature of this discovery, and the mystery of the ribbon-like nature of the sticky lines in the inner portion of the web (such band-like cribellum lines have never been described in any other species) emphasize a second general theme: our knowledge of spider webs (especially non-orb webs) is still profoundly incomplete (from Agnarsson et al. 2012; courtesy Ingi Agnarsson)")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "piv"
    }
  }), _vm._v("The University of Chicago Press, Chicago 60637")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("The University of Chicago Press, Ltd., London")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("Cover design and text design © 2020 The University of Chicago")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("All rights reserved. No copyright is claimed for the original text of "), _c('i', [_vm._v("Spider Webs: Behavior, Function, and Evolution")]), _vm._v(", although some text and illustrations included in the book may be copyright protected.")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("For more information, contact the University of Chicago Press, 1427 E. 60th St., Chicago, IL 60637.")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("Published 2020")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("Printed in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("29 28 27 26 25 24 23 22 21 20 1 2 3 4 5")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("ISBN")]), _vm._v("-13: 978-0-226-53460-2 (cloth)")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("ISBN")]), _vm._v("-13: 978-0-226-53474-9 (e-book)")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("DOI")]), _vm._v(": "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://doi.org/10.7208/chicago/9780226534749.001.0001",
      "target": "_blank"
    }
  }, [_vm._v("https://doi.org/10.7208/chicago/9780226534749.001.0001")])]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("Additional parts of this large project are archived online at "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.press.uchicago.edu/sites/eberhard/",
      "target": "_blank"
    }
  }, [_vm._v("press.uchicago.edu/sites/eberhard/")]), _vm._v("; these portions are designated in the text with a capital O followed by the book chapter to which they refer (e.g., section O6.1; table O3.3; fig. O9.1).")]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Names: Eberhard, William G., author.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Title: Spider webs : behavior, function, and evolution / William Eberhard.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Description: Chicago : University of Chicago Press, 2020. | Includes bibliographical references and index.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Identifiers: "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("LCCN")]), _vm._v(" 2019050065 | "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ISBN")]), _vm._v(" 9780226534602 (cloth) | "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ISBN")]), _vm._v(" 9780226534749 (ebook)")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Subjects: "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("LCSH")]), _vm._v(": Spider webs. | Spiders—Behavior.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Classification: "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("LCC")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("QL")]), _vm._v("458.4 ."), _c('span', {
    staticClass: "sm"
  }, [_vm._v("E")]), _vm._v("24 2020 | "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("DDC")]), _vm._v(" 595.4/4156—dc23")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("LC")]), _vm._v(" record available at "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://lccn.loc.gov/2019050065",
      "target": "_blank"
    }
  }, [_vm._v("https://lccn.loc.gov/2019050065")])]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("♾ This paper meets the requirements of "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ANSI/NISO")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("Z")]), _vm._v("39.48-1992 (Permanence of Paper).")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51918af2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-eberhard-0005.vue
// module id = 66
// module chunks = 0